/* eslint-disable @typescript-eslint/no-unsafe-return */
import { Box, Button, Modal } from '@amzn/awsui-components-react';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { i18nKeys } from '../../utils/i18n.utils';
import { Markdown } from '../common/Markdown';

export interface DisplayHTMLModalProps {
  title?: string;
  message?: string;
  closeBtnLabel?: string;
  cancelBtnLabel?: string;
  visible: boolean;
  size?: 'small' | 'medium' | 'large';
  disabled?: boolean;
  onClose: () => any;
  'data-testid'?: string;
}

export const DisplayHTMLModal: React.FC<DisplayHTMLModalProps> = ({
  title,
  message,
  closeBtnLabel,
  cancelBtnLabel,
  visible,
  size,
  onClose,
  disabled = false,
  ...rest
}) => {
  const { t } = useTranslation();
  return (
    <Modal
      visible={visible}
      size={size || 'large'}
      header={title || t(i18nKeys.general.confirm)}
      onDismiss={() => onClose()}
      closeAriaLabel={t(i18nKeys.general.close)}
      data-testid={rest['data-testid']}
      footer={
        <Box float="right" className="awsui-util-f-r">
          <Button disabled={disabled} variant="primary" onClick={() => onClose()}>
            {closeBtnLabel || t(i18nKeys.general.close)}
          </Button>
        </Box>
      }
    >
      <div style={{ width: 'auto', overflow: 'auto' }}>
        <Markdown content={message || ''} allowHtml />
      </div>
    </Modal>
  );
};
